import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconPlanOfCare = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--plan-of-care")} iconColor={color} size={size} width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

      <defs>
          <path d="M15,1 C16.1045695,1 17,1.8954305 17,3 L18,3 C19.6568542,3 21,4.34314575 21,6 L21,6 L21,20 C21,21.6568542 19.6568542,23 18,23 L18,23 L6,23 C4.34314575,23 3,21.6568542 3,20 L3,20 L3,6 C3,4.34314575 4.34314575,3 6,3 L6,3 L7,3 C7,1.8954305 7.8954305,1 9,1 L15,1 Z M7,5 L6,5 C5.44771525,5 5,5.44771525 5,6 L5,6 L5,20 C5,20.5522847 5.44771525,21 6,21 L6,21 L18,21 C18.5522847,21 19,20.5522847 19,20 L19,20 L19,6 C19,5.44771525 18.5522847,5 18,5 L18,5 L17,5 C17,6.1045695 16.1045695,7 15,7 L9,7 C7.8954305,7 7,6.1045695 7,5 Z M12,9 C12.5522847,9 13,9.44771525 13,10 L13,10 L13,13 L16,13 C16.5128358,13 16.9355072,13.3860402 16.9932723,13.8833789 L17,14 C17,14.5522847 16.5522847,15 16,15 L16,15 L13,15 L13,18 C13,18.5128358 12.6139598,18.9355072 12.1166211,18.9932723 L12,19 C11.4477153,19 11,18.5522847 11,18 L11,18 L11,15 L8,15 C7.48716416,15 7.06449284,14.6139598 7.00672773,14.1166211 L7,14 C7,13.4477153 7.44771525,13 8,13 L8,13 L11,13 L11,10 C11,9.48716416 11.3860402,9.06449284 11.8833789,9.00672773 Z M15,3 L9,3 L9,5 L15,5 L15,3 Z" id="icon--centivo--plan-of-care"/>
      </defs>
      <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-871.000000, -973.000000)"/>
          <g id="Icon/plan-of-care">
              <mask id="mask-2" fill="white">
                  <use xlinkHref="#icon--centivo--plan-of-care"/>
              </mask>
              <use id="Shape" fill="currentColor" xlinkHref="#icon--centivo--plan-of-care"/>
          </g>
      </g>
  </IconWrapper>
)
